import React from 'react';
import classes from './sixYardExperience.module.css';
import Title from '../../containers/title/title';
import Button from '../../containers/button/button';
import { useNavigate } from 'react-router';
import { getImageUrl } from '../../../utils/imageUrl';
const SixYardExperience = (props) => {
    const navigate = useNavigate();
    const bookNowClicked = () => {
        if (!props.isAuthenticated) props.setShowLoginForm(true)
        else navigate('/field-booking')
    }
    return (
        <div className={classes.SixYardExperience}>
            <Title title={props.experienceSection?.title} />
            <div className={classes.Discreption} dangerouslySetInnerHTML={{ __html: props.experienceSection?.content }} />
            <ul className={classes.SixYardExperienceList}>{props.services?.map(service =>
                <li key={service.id}>
                    <img src={getImageUrl(service.icon)} alt={service.title} />
                    <span>{service.title}</span>
                </li>
            )}</ul>
            <Button 
                content={parseInt(localStorage.getItem('language')) === 1 ? "BOOK NOW" : "احجز الآن"} 
                onClick={bookNowClicked} 
            />
        </div>
    )
}
export default SixYardExperience;